import moment from 'moment';
import 'moment/locale/th';
class PlanShape {

    constructor() {
        this.key = Math.random().toString(36).substring(0);
        this.uid = ''

        // Raw data
        this.type = 'polygon';
        this.createdAt = null;
        this.updatedAt = null;
        
        this.name = ''
        this.description = ''

        // Relational data
        this.planUid = ''
        this.userUid = ''

        // Object data
        this.coordsArray = [];
    }

    static initBySnapshot(docSnapshot) {
        const obj = docSnapshot.data();
        const shape = new PlanShape();

        shape.uid = docSnapshot.id;
        obj.type !== undefined ? shape.type = obj.type : shape.type = 'polygon'
        obj.name !== undefined ? shape.name = obj.name : shape.name = shape.type
        shape.name = ( shape.name !== '') ? shape.name : shape.type
        shape.createdAt = ( obj.created_date !== undefined && obj.created_date !== null ) ? obj.created_date.toDate() : null;
        shape.updatedAt = ( obj.updated_date !== undefined && obj.created_date !== null ) ? obj.updated_date.toDate() : null;

        shape.userUid = ( obj.uid !== undefined ) ? obj.uid : '';
        shape.planUid = ( obj.plan !== undefined ) ? obj.plan : '';

        if ( obj.points !== undefined ) {
            shape.coordsArray = obj.points.map((coord) => {
                return {lat: coord._lat, lng: coord._long};
            });
        }
        return shape;
    }

    allLengthTuples() {
        var coordsTuplesArray = [];

        if ( this.coordsArray.length >= 2 ) {
            for ( var i = 1; i < this.coordsArray.length; i++ ) {
                const coord1 = this.coordsArray[i - 1];
                const coord2 = this.coordsArray[i];
                const tuple = {
                    coord1: coord1,
                    coord2: coord2
                };
                coordsTuplesArray.push(tuple);
            }

            if ( this.type === 'polygon' ) {
                const coord1 = this.coordsArray[this.coordsArray.length - 1];
                const coord2 = this.coordsArray[0];
                const tuple = {
                    coord1: coord1,
                    coord2: coord2
                };
                coordsTuplesArray.push(tuple);
            }
        }

        return coordsTuplesArray
    }

    shapeLatLng() {
        return this.coordsArray[0];
    }

    shapeArea() {
        if ( window.google === undefined || this.coordsArray.length === 0 ) {
            return null;
        }
        
        const latLngArray = this.coordsArray.map((coord) => {
            return new window.google.maps.LatLng({lat: coord.lat, lng: coord.lng});
        });
        const sqrMeter = window.google.maps.geometry.spherical.computeArea(latLngArray);
    
        const rawRai = sqrMeter/1600.00;
        const rai = Math.floor(rawRai);
        
        const rawNgan = (sqrMeter - (rai * 1600.0)) / 400.0;
        const ngan = Math.floor(rawNgan);
        
        const rawWa = (sqrMeter - ( (rai * 1600.0) + (ngan * 400.0) )) / 4.0;
        const wa = Math.floor(rawWa);
        
        return {
            sqrMeter: sqrMeter,
            rai: rai,
            ngan: ngan,
            wa: wa
        };
    }

    shapeDistance (){
        if ( window.google === undefined || this.coordsArray.length === 0 ) {
            return null;
        }
        
        const latLngArray = this.coordsArray.map((coord) => {
            return new window.google.maps.LatLng({lat: coord.lat, lng: coord.lng});
        });
        const distance = window.google.maps.geometry.spherical.computeLength(latLngArray);
        
        const rawKilometer = distance/1000.00
        const kilometer = Math.floor(rawKilometer)

        const rawMeter = distance - (kilometer*1000)
        const meter = Math.floor(rawMeter)

        var textArray = []

        if( kilometer > 0 ){
            const text = '' + kilometer + ' กิโลเมตร'
            textArray.push(text)
        }
        const text = '' + meter +' เมตร'
        textArray.push(text)

        return textArray.join(' ')
    }

    shapeAreaString() {
        const area = this.shapeArea();
        if ( area === null ) {
            return null;
        }
        const { rai, ngan, wa } = area;
        var textArray = [];
        if ( rai > 0 ) {
            const text = '' + rai + ' ไร่';
            textArray.push(text);
        }
        if ( ngan >0 ) {
            const text = '' + ngan + ' งาน';
            textArray.push(text);
        }
        if  ( wa > 0 ) {
            const text = '' + wa + ' ตร.วา';
            textArray.push(text);
        }
        return textArray.join(' ');
    }

    createdAtString() {
        if ( this.createdAt === null ) return null;
        return moment(this.createdAt).locale('th').format('D MMMM YYYY');
    }

    hasAnyGeneralDetails() {
        return ( this.address !== '' ) || ( this.deed !== '' ) || ( this.description !== '' );
    }

}

export default PlanShape;


// WEBPACK FOOTER //
// ./src/Models/PlanShape.js